import PhoneIphoneOutlined from '@mui/icons-material/PhoneIphoneOutlined';
import WatchLaterOutlined from '@mui/icons-material/WatchLaterOutlined';
import { Grid, Stack, Typography } from '@mui/material';
import useTranslation, { Translation } from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { tooltipPalette } from 'theme/tooltipPalette';
import { ColumnHeaderWithTooltip } from 'v2/components/ColumnHeaderWithTooltip/ColumnHeaderWithTooltip';

interface StatusLegendEntry {
  label: string;
  icon: React.ReactElement;
}

const getConnectivityLegendEntries = (translation: Translation): StatusLegendEntry[] => [
  {
    label: translation.status_tooltip_config_app_disconnected,
    icon: <PhoneIphoneOutlined fontSize="small" sx={{ fill: tooltipPalette.error.main }} />
  },
  {
    label: translation.status_tooltip_access_app_disconnected,
    icon: <PhoneIphoneOutlined fontSize="small" sx={{ fill: tooltipPalette.error.main }} />
  },
  {
    label: translation.status_tooltip_access_app_disconnected_but_user_has_card,
    icon: <PhoneIphoneOutlined fontSize="small" sx={{ fill: tooltipPalette.warning.main }} />
  },
  {
    label: translation.status_tooltip_apps_connected,
    icon: <PhoneIphoneOutlined fontSize="small" sx={{ fill: tooltipPalette.success.main }} />
  }
];

const getExpirationLegendEntries = (translation: Translation): StatusLegendEntry[] => [
  {
    label: translation.expires_in_24h,
    icon: <WatchLaterOutlined fontSize="small" sx={{ fill: tooltipPalette.error.main }} />
  },
  {
    label: translation.expires_this_week,
    icon: <WatchLaterOutlined fontSize="small" sx={{ fill: tooltipPalette.warning.main }} />
  }
];

const LegendColumn: React.FC<{ entries: StatusLegendEntry[] }> = ({ entries }) => (
  <Stack spacing={1}>
    {entries.map((entry) => (
      <Stack key={entry.label} direction="row" alignItems="center" spacing={1}>
        {entry.icon}
        <Typography variant="caption">{entry.label}</Typography>
      </Stack>
    ))}
  </Stack>
);

export const StatusColumnHeader: React.FC = () => {
  const { translation } = useTranslation();

  return (
    <ColumnHeaderWithTooltip
      label={translation.status}
      tooltip={
        <Stack spacing={1.5}>
          <Typography variant="caption">{translation.status_tooltip_description}</Typography>
          <Grid container spacing={1.5}>
            <Grid size={6}>
              <LegendColumn entries={getConnectivityLegendEntries(translation)} />
            </Grid>
            <Grid size={6}>
              <LegendColumn entries={getExpirationLegendEntries(translation)} />
            </Grid>
          </Grid>
        </Stack>
      }
    />
  );
};
